// Tuân thủ thuế sàn hợp tác creator: mã lỗi cần đồng ý điều khoản và kiểm mã số thuế — PHẢI khớp payment (CreatorTaxCode, BrandTaxConsentGate).

export const BRAND_TAX_CONSENT_CODE = 'BRAND_TAX_CONSENT_REQUIRED';
export const BRAND_TAX_POLICY_KEY = 'brand-creator-tax';
export const TAX_CODE_INVALID_MESSAGE =
  'Mã số thuế phải gồm 10 hoặc 12 chữ số (có thể kèm -XXX cho đơn vị phụ thuộc).';

const TAX_CODE_PATTERN = /^([0-9]{10}(-[0-9]{3})?|[0-9]{12})$/;

export const normalizeTaxCode = (raw: string): string => raw.replace(/\s+/g, '');

/** null = hợp lệ (kể cả để trống, nghĩa là không khai hoặc xoá); ngược lại là câu lỗi đúng như máy chủ. */
export const validateTaxCode = (raw: string): string | null => {
  const value = normalizeTaxCode(raw);
  if (!value) return null;
  return TAX_CODE_PATTERN.test(value) ? null : TAX_CODE_INVALID_MESSAGE;
};

export const isBrandTaxConsentError = (err: unknown): boolean =>
  (err as { response?: { data?: { code?: string } } } | undefined)?.response?.data?.code === BRAND_TAX_CONSENT_CODE;
